import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Card, Text } from '@iwoca/orion';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { TickSVG } from '@svgComponents/tickSVG';
import { FormattedMessage } from 'react-intl';

export const CreditCompassDeclineView = () => {
    const impersonatingStateKey = getQueryParameter(
        getCurrentLocation(),
        'state_key'
    );

    useEffect(() => {
        tracking.ampli.creditCompassDeclinePageViewed();
    }, []);

    const navigateToCreditCompass = async () => {
        tracking.ampli.creditCompassDeclineCtaClicked();

        await tracking.ampli.flush().promise;

        window.location.href = `/credit-compass${impersonatingStateKey ? `?state_key=${impersonatingStateKey}&credit_compass_source=declined_view` : '?credit_compass_source=declined_view'}`;
    };

    return (
        <Card className="m-auto w-[550px] border-none p-xl shadow-blue-s max-sm:m-auto max-sm:w-full">
            <Text className="text-center text-2xl font-bold">
                <FormattedMessage
                    id="_.declined_view.credit_compass_decline_view.title"
                    defaultMessage="Sorry, we can’t approve your application today for a Flexi-Loan."
                />
            </Text>
            <Text className="my-xl text-center text-m">
                <FormattedMessage
                    id="_.declined_view.credit_compass_decline_view.subtitle"
                    defaultMessage="But we can help you improve your credit score for future applications."
                />
            </Text>

            <Card className="border-none p-xl shadow-blue-m">
                <div className="flex flex-row flex-wrap justify-between max-sm:flex-col max-sm:items-start">
                    <Text className="pb-l text-2xl font-med">
                        <FormattedMessage
                            id="_.declined_view.credit_compass_decline_view.credit_compass_title"
                            defaultMessage="Take control of your business health with our Credit Compass"
                        />
                    </Text>

                    <div>
                        <div className="flex flex-row justify-between max-sm:flex-col max-sm:items-start">
                            <TickSVG width="25" height="25" className="mr-m" />
                            <Text className="pb-l text-m font-reg">
                                <FormattedMessage
                                    id="_.declined_view.credit_compass_decline_view.credit_compass_feature_1"
                                    defaultMessage="<bold>Free Equifax Score:</bold> see where you stand and track changes with a refresh every month"
                                    values={{
                                        bold: (chunks: string) => (
                                            <strong>{chunks}</strong>
                                        )
                                    }}
                                />
                            </Text>
                        </div>

                        <div className="flex flex-row justify-between max-sm:flex-col max-sm:items-start">
                            <TickSVG width="25" height="25" className="mr-m" />
                            <Text className="pb-l text-m font-reg">
                                <FormattedMessage
                                    id="_.declined_view.credit_compass_decline_view.credit_compass_feature_2"
                                    defaultMessage="<bold>Understand your business health:</bold> with explanations of what lenders look at and how to improve"
                                    values={{
                                        bold: (chunks: string) => (
                                            <strong>{chunks}</strong>
                                        )
                                    }}
                                />
                            </Text>
                        </div>

                        <div className="flex flex-row justify-between max-sm:flex-col max-sm:items-start">
                            <TickSVG width="25" height="25" className="mr-m" />
                            <Text className="pb-l text-m font-reg">
                                <FormattedMessage
                                    id="_.declined_view.credit_compass_decline_view.credit_compass_feature_3"
                                    defaultMessage="<bold>Get approved in the future:</bold> set a plan to improve your business health to strengthen future applications"
                                    values={{
                                        bold: (chunks: string) => (
                                            <strong>{chunks}</strong>
                                        )
                                    }}
                                />
                            </Text>
                        </div>
                    </div>
                </div>
                <Button
                    onClick={navigateToCreditCompass}
                    className="mt-xl w-full"
                >
                    Get started
                </Button>
            </Card>
        </Card>
    );
};
